import React, { Component } from 'react';

export default class DetalhesCentroCusto extends Component {
    render() {
        if (!this.props.centroCusto.exibirDetalhe) {
            return ''
        }
        return (
            <div className="vx-cc-detail">
                <div className="vx-cc-detail-label">Ocorrência</div>
                <div className="vx-cc-detail-value">{this.props.centroCusto.ocorrencia}</div>
            </div>
        )
    }
}
